export const GET_N_NOTIFICATION_SUCCESS = "GET_N_NOTIFICATION_SUCCESS";
export const FLAG_NOTIFICATION_SUCCESS = "FLAG_NOTIFICATION_SUCCESS";
export const UNFLAG_NOTIFICATION_SUCCESS = "UNFLAG_NOTIFICATION_SUCCESS";
export const READ_NOTIFICATION_SUCCESS = "READ_NOTIFICATION_SUCCESS";
export const UNREAD_NOTIFICATION_SUCCESS = "UNREAD_NOTIFICATION_SUCCESS";
export const GET_UNREAD_NOTIFICATION_COUNT_SUCCESS = "GET_UNREAD_NOTIFICATION_COUNT_SUCCESS";
